module.exports = __webpack_public_path__ + "img/20190813160302714.7c730604.png";